import {language} from "../enum/language";
import {breakpoint} from "../enum/breakpoint";
import {MIN_SLIDES_TO_SHOW_ARROWS_ON_DESKTOP, NUMBER_OF_CARDS_ON_FIRST_CLICK, NUMBER_OF_CARDS_ON_LOAD, NUMBER_OF_CARDS_ON_SECOND_CLICK, pagesEnum, URLS} from "../constants/constants";
import {Contest} from "../interface/interfaces";
import {getTraduction, traductionEnum} from "./traduction";
import {pushEventLightbox} from './cybermetrie.js';
import {contestType} from '../enum/contest';

export const SCROLL_HEADER = 'scroll';
let lang: string = determineLanguage();

// Scroll to specified element, if no element specified, scroll to top
export function scrollToElement($element?: JQuery<HTMLElement>, offset?: number, focus?: boolean) {
    $('html, body').animate({
        scrollTop: $element ? ($element?.offset()?.top || 0) + (offset || 0) : 0
    }, 1000);
    focus && $element ? $element.focus() : null;
}

export function setActiveTab($this: JQuery, elementId?: string) {
    if (elementId) {
        $(elementId).find('.tab-item').each(function () {
            $(this).removeClass('active-tab')
        });
        $this.addClass('active-tab');
    } else {
        $('.active-tab').removeClass('active-tab');
        $this.addClass('active-tab');
    }

}

export function determineLanguage(): string {
    const lang_generic: string[] | undefined = $('html').attr('lang')?.split('-');
    return lang_generic ? lang_generic[0] : language.french;
}

export function getCurrentLocale(): string {
    const lang_generic: string | undefined = $('html').attr('lang');
    return lang_generic ? lang_generic : 'fr-CA';
}

export function formatAmountInDollar(value: number) {
    return new Intl.NumberFormat(getCurrentLocale(), {
        style: 'currency', currency: 'CAD', maximumFractionDigits: 0,
        minimumFractionDigits: 0
    }).format(value);
}

// animation loader
export function loaderAnimation(elm: JQuery<HTMLElement>, isInModal: boolean) {
    let $this = $(elm);
    const $loaderContainer = $('<div/>', {'class': 'container-loader-animation'});
    if (isInModal) $loaderContainer.css('z-index', 99993);
    let $bulleAnime = $('<span/>', {'class': 'loading-bubble'});
    let $bulleAnime2 = $('<span/>', {'class': 'loading-bubble'});
    let $bulleAnime3 = $('<span/>', {'class': 'loading-bubble'});
    $loaderContainer.append($bulleAnime, $bulleAnime2, $bulleAnime3);

    $this.prepend($loaderContainer);
    $this.addClass('loading-progress');
}

export function removeLoaderAnimation(elm: JQuery<HTMLElement>) {
    let $this = $(elm);
    $this.removeClass('loading-progress');
    $('.container-loader-animation').remove();
}

export function formatCouponDateToString(date: string | undefined, lang: string) {
    // Options for formatting
    let options: Intl.DateTimeFormatOptions = {year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric"};

    // Formatting date
    let formatter = new Intl.DateTimeFormat(lang, options);
    let formattedDate = formatter.format(new Date(Date.parse(date ? date : '')));

    // Adding 'le ' at the beginning of the date in French
    let output = lang === language.french ? 'le ' : '';

    return output.concat(`${formattedDate}`);
}

export const redirectTo = (url: pagesEnum) => {
    Object.entries(URLS).map(([name, urlFrEn]) => name.toString() === pagesEnum[url] ? determineLanguage() === language.french ? window.location.href = urlFrEn.fr : window.location.href = urlFrEn.en : '');
}

export const getUrls = (page: pagesEnum): any => {
    let result;
    let isLangFrench = determineLanguage() === language.french;

    Object.entries(URLS).map(([enumName, values]) => {
        if (enumName.toString() === pagesEnum[page]) {
            result = isLangFrench ? values.fr : values.en;
        }
    });
    return result;
}

export function handleSliderArrows(slider: string, prev: string, next: string, options: JQuerySlickOptions) {
    let slidesCount = $(slider).slick('getSlick').$slides?.length || 0
    // needed to prevent recursive calls to the function removeOrAddSlickOnSizeChange
    let firstIteration = true;
    let destroyed = false;
    let $slider = $(slider)
    let $prev = $(prev)
    let $next = $(next)

    function removeOrAddSlickOnSizeChange() {
        if ($(window).width() && $(window).width()! >= breakpoint.desktop && slidesCount < MIN_SLIDES_TO_SHOW_ARROWS_ON_DESKTOP) {
            $prev.css('visibility', 'hidden');
            $next.css('visibility', 'hidden');
            $slider.on('destroy', function (event, slick) {
                destroyed = true;
            })
            $slider.slick('unslick');
            $slider.addClass('center-all gap-2');
        } else {
            $slider.removeClass('center-all gap-2');
            if (destroyed) {
                $slider.slick(options);
                destroyed = false;
            }
            $prev.css('visibility', 'visible');
            $next.css('visibility', 'visible');
        }
    }

    // Go to the last slide
    $prev.on('click', function () {
        if ($prev.hasClass('slick-disabled')) {
            $slider.slick('slickGoTo', slidesCount - 1, false);
        }
    });

    // Return to the first slide
    $next.on('click', function () {
        if ($next.hasClass('slick-disabled')) {
            $slider.slick('slickGoTo', 0, false);
        }
    });

    $(window).on('resize', function () {
        removeOrAddSlickOnSizeChange();
    });

    // Needed to trigger the function on first load
    if (firstIteration) {
        removeOrAddSlickOnSizeChange();
        firstIteration = false;
    }
}

export function privilegeSlider(sliderClassname: string) {
    $(() => {
        const options = {
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            infinite: false,
            variableWidth: false,
            centerMode: false,
            swipeToSlide: true,
            slidesToShow: 5,
            centerPadding: '1rem',
            responsive: [
                {
                    breakpoint: 2100,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1750,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: breakpoint.desktop,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: breakpoint.tablet,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        };

        $(sliderClassname).slick(options);

        $('.slick-slide').attr({'aria-hidden': 'false', 'tabindex': '-1'});

        handleSliderArrows(sliderClassname, '.prev', '.next', options)
    })
}

export function displayCard(cards: JQuery<HTMLElement>, numberOfCards: number, buttonClicked: JQuery<HTMLElement>, moveFocus: boolean): number {
    let numberOfCouponsCounted = 0;
    // Iterate through cards to make them visible
    cards.children().each(function () {
        if (numberOfCards < 0 || numberOfCouponsCounted < numberOfCards) $(this).removeClass('hidden');
        else return;
        numberOfCouponsCounted++;
    });

    if (moveFocus) {
        if (numberOfCards == NUMBER_OF_CARDS_ON_FIRST_CLICK) {
            buttonClicked.text();
            cards.children()[NUMBER_OF_CARDS_ON_LOAD].focus();
        } else if (numberOfCards == NUMBER_OF_CARDS_ON_SECOND_CLICK) {
            cards.children()[NUMBER_OF_CARDS_ON_FIRST_CLICK].focus();
        }
    }

    // Hide the see more button if there are fewer cards than numberOfCard to display, or if it's the same amount of total cards
    if (numberOfCards < 0 || numberOfCouponsCounted < numberOfCards || cards.children().length === numberOfCouponsCounted) {
        buttonClicked.parent().hide();
    }

    return numberOfCards;
}

export function handleClickOnSeeMoreButton($buttonClicked: JQuery<HTMLElement>, $elementsContainer: JQuery<HTMLElement>, buttonAlreadyClicked: boolean): number {
    // Display all cards if button is clicked for the second time, otherwise display cards according to the number set on first click
    return buttonAlreadyClicked ? displayCard($elementsContainer, NUMBER_OF_CARDS_ON_SECOND_CLICK, $buttonClicked, true) : displayCard($elementsContainer, NUMBER_OF_CARDS_ON_FIRST_CLICK, $buttonClicked, true);
}

export function scrollToTopIfScrollHeader(scrollHeader: string | null) {
    if (scrollHeader === SCROLL_HEADER) scrollToElement();
}

export function handleModalIfError(jqXHR: any) {
    if (jqXHR.getResponseHeader(SCROLL_HEADER)) $.fancybox.close();
    scrollToTopIfScrollHeader(jqXHR.getResponseHeader(SCROLL_HEADER));
}

export function getContest(contestList: Contest[], id: number): Contest | undefined {
    return contestList.find((item) => item.id === id);
}

export function fillModal($element: JQuery<HTMLElement>, contestList: Contest[], modalId: string) {
    let $modal = $(modalId);
    let lang: string = determineLanguage();

    let id = Number($element.attr("data-cId"));
    let clickedContest = getContest(contestList, id);
    // Should not happen
    if (!clickedContest) return;

    // Title
    let modalCouponLine1 = $modal.find(".title > h3");
    modalCouponLine1.text(clickedContest.title);

    // Find the icon and text in the grid and replaces it in the modal
    let modalContestCategoryTitle = $modal.find(".section-title");
    let contestIconAndType = $element.find(".contest-card-title");
    modalContestCategoryTitle.empty().append(contestIconAndType.html());

    // Find the icon and text in the grid and replaces it in the modal
    let modalContestbrand = $modal.find(".bottom-brand");
    let contestIconAndTextBrand = $element.find(".card-tile-bottom-container").children().first();
    modalContestbrand.empty().append(contestIconAndTextBrand.html());

    // Dates
    let modalDateContainer = $modal.find(".modal-coupon-date");

    // StartDate
    let startDateHtml = getTraduction(traductionEnum.START_BY);
    let modalStartDate = modalDateContainer.children().first();
    let formattedStartDate = formatCouponDateToString(clickedContest.validityStartDate, lang);
    modalStartDate.html(startDateHtml.concat(formattedStartDate));

    // EndDate
    let endDateHtml = getTraduction(traductionEnum.ENDS_BY);
    let modalEndDate = modalStartDate.next();
    let formattedEndDate = formatCouponDateToString(clickedContest.validityEndDate, lang);
    modalEndDate.html(endDateHtml.concat(formattedEndDate));

    // Img
    let modalCouponImg = $modal.find("> img");
    modalCouponImg.replaceWith(clickedContest.imageDesktop);

    // Content
    let $modalContentSection = $modal.find('.content');
    $modalContentSection.empty().append(clickedContest.content);

    // if category is flyer
    if (contestType.FLYER.startsWith(clickedContest.category.toLowerCase())){
        // @ts-ignore
        window.open(clickedContest.urlFlyer, '_blank').focus();
        return;
    }

    // Opening the modal
    $.fancybox.open({
        src: modalId,
        type: 'inline'
    }, {
        autoFocus: false,
        touch: false,
        beforeShow: function () {
            $("body").css({'overflow-y': 'hidden'});
        },
        afterShow: function () {
            changeLangTitle()
        },
        afterClose: function () {
            $("body").css({'overflow-y': 'visible'});
            $($element).focus()
        }
    });
    pushEventLightbox('contest ' + clickedContest.title);

}

export function contestCardClickEvent(contestList: any, modalId: string) {
    // Setting the event on coupon click
    $('.contest-card').each(function () {
        handleDragAndClick($(this), () => {
            fillModal($(this), contestList, modalId);
        })
    })
}

export function bindOpenModalOnPrivilegesClick() {
    function handlePrivilege($element: JQuery<HTMLElement>) {
        let content = $element.attr("data-pContent");
        let image = $element.attr("data-pImage");
        let title = $element.attr("data-pTitle");
        let type = $element.attr("data-pType");
        let startDate = $element.attr("data-pStartDate");
        let endDate = $element.attr("data-pEndDate");

        // @ts-ignore
        $('#modal-privilege-img').html(image);
        // @ts-ignore
        $('#modal-privilege-title').text(title);
        // @ts-ignore
        $('#modal-privilege-subtitle').text(type);

        let modalPrivilegeDateContainer = $('#modal-privilege-date');

        // StartDate
        let startDateHtml = getTraduction(traductionEnum.START_BY);
        let modalStartDate = modalPrivilegeDateContainer.children().first();
        let formattedStartDate = formatCouponDateToString(startDate, lang);
        modalStartDate.html(startDateHtml.concat(formattedStartDate));

        // EndDate
        let endDateHtml = getTraduction(traductionEnum.ENDS_BY);
        let modalEndDate = modalStartDate.next();
        let formattedEndDate = formatCouponDateToString(endDate, lang);
        modalEndDate.html(endDateHtml.concat(formattedEndDate));

        // @ts-ignore
        $('#modal-privilege-content').html(content);

        addAnimationOnButtons()
        addFocusOnButtons()
        addDescritionExternalLink()

        // Opening the modal
        $.fancybox.open({
            src: '#privilege-modal-open',
            type: 'inline'

        }, {
            autoFocus: false,
            touch: false,
            beforeShow: function () {
                $("body").css({'overflow-y': 'hidden'});
            },
            afterShow: function () {
                changeLangTitle()
            },
            afterClose: function () {
                $("body").css({'overflow-y': 'visible'});
                $($element).focus()
            }
        });
        pushEventLightbox('privilege ' + title);
    }

    let $cardPrivilege = $('.privilege-card');
    $cardPrivilege.each(function () {
        handleDragAndClick($(this), () => {
            handlePrivilege($(this));
        })
    })
}

export function handleDragAndClick($element: JQuery<HTMLElement>, callBack: (event: any) => void) {
    let beginsAt: number;
    let endsAt: number;
    let delta: number;
    const maxDraggingToBeConsideredClick = 30;

    $element.on('mousedown', function (event) {
        beginsAt = event.clientX;
    })
        .on('mousemove', function (event) {
            endsAt = event.clientX;
        }).on('mouseup', function (event) {
        delta = Math.abs(Math.abs(endsAt) - Math.abs(beginsAt));

        if (delta < maxDraggingToBeConsideredClick) {
            callBack(event);
        }
    });
    $element.on('keyup', function (event) {
        event.stopPropagation();
        if (event.key === 'Enter') {
            callBack(event);
        }
    }).on('keydown', function (event) {
        // This prevents the keydown to be called
        if (event.key === 'Enter') {
            event?.preventDefault();
        }
    });
}

export function addAnimationOnButtons() {
    /* Wrap all btn with a span for the animation */
    let $cta = $(".btn:not([data-pass-anim])")
    $cta.each(function () {
        $(this).contents().wrap("<span/>");
        $(this).attr("data-pass-anim", "1")
    });
}

export function addFocusOnButtons() {
    /* Wrap all btn with a span for the animation */
    let $cta = $(".btn:not([data-pass-focus])")
    const spanAdd = '<span class="focus-style"></span>'
    $cta.each(function () {
        $(this).append(spanAdd);
        $(this).attr("data-pass-focus", "1")
    });
}

export function addDescritionExternalLink() {
    /* add description to external link */
    let $cta = $(".btn-exteral-link")
    $cta.each(function () {
        let $ctaValue = $(this).text()
        $(this).attr("aria-label", $ctaValue + " " + getTraduction(traductionEnum.OPEN_NEW_WINDOWS));
    });
}

export function changeLangTitle() {
    $('[data-fancybox-close]').attr('title', getTraduction(traductionEnum.CLOSE));
}

export function getCookie(cookieName: string) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + cookieName + "=");

    if (parts.length === 2) {
        return parts.pop()?.split(";").shift();
    }
    return '';
}

export function setCookie(cookieName: string, expirationDays: number) {
    let expDate = new Date();
    expDate.setDate(expDate.getDate() + expirationDays);
    document.cookie = cookieName + "=true; expires=" + expDate.toUTCString() + "; path=/";
}

export function setCookieByValue(cookieName: string, value: string, expirationDays: number) {
    let expDate = new Date();
    expDate.setDate(expDate.getDate() + expirationDays);
    document.cookie = cookieName + "=" + value + "; expires=" + expDate.toUTCString() + "; path=/";
}